
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`TypeScript Plugin`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/Igorbek/typescript-plugin-styled-components"
      }}><inlineCode parentName="a">{`typescript-plugin-styled-components`}</inlineCode></a>{` is a plugin for TypeScript that gives you a nicer debugging experience.`}</p>
    <blockquote>
      <p parentName="blockquote">{`⚠️ TypeScript does not allow to use any plugin or transformer directly from the command line compiler `}<inlineCode parentName="p">{`tsc`}</inlineCode>{`. So the plugin only works with build toolchains such as `}<inlineCode parentName="p">{`webpack`}</inlineCode>{` with one of TypeScript loaders. There's `}<a parentName="p" {...{
          "href": "https://github.com/Microsoft/TypeScript/issues/16607"
        }}>{`an open issue`}</a>{` to bring plugins to tsc though if you want to upvote it!`}</p>
    </blockquote>
    <p>{`Please refer to `}<a parentName="p" {...{
        "href": "https://github.com/Igorbek/typescript-plugin-styled-components"
      }}>{`the project's GitHub repo`}</a>{` for documentation.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;